import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppToastManagerService } from '../../../../shared/services/toast-manager.service';
import { AppEventService } from '../../events.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../../../../shared/base-classes/base.component';
import { EventCategoryCreateUpdateDto } from '@whetstoneeducation/hero-common';

@Component({
  selector: 'app-event-category-create-edit-modal',
  templateUrl: './event-category-create-edit-modal.component.html',
  styleUrls: ['./event-category-create-edit-modal.component.scss']
})
export class EventCategoryCreateEditModalComponent
  extends BaseComponent
  implements OnInit
{
  public nameControl = new FormControl('');
  public isCreating: boolean = true;
  public onClose: () => void;

  constructor(
    public toastService: AppToastManagerService,
    public eventsService: AppEventService,
    public dialogRef: MatDialogRef<EventCategoryCreateEditModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      id?: number;
      onClose?: () => void;
    }
  ) {
    super();
  }

  async ngOnInit() {
    this.isLoading = true;
    if (this.data.id) {
      this.isCreating = false;
      const eventCategory = await this.eventsService.getEventCategory(
        this.data.id
      );
      this.nameControl.setValue(eventCategory.name);
    }
    this.isLoading = false;
  }

  async submit() {
    this.isLoading = true;
    const createUpdateDto = new EventCategoryCreateUpdateDto({
      name: this.nameControl.value
    });

    if (this.isCreating) {
      await this.eventsService.createEventCategory(createUpdateDto);
    } else {
      await this.eventsService.updateEventCategory(
        this.data.id,
        createUpdateDto
      );
    }
    this.isLoading = false;
    this.dialogRef.close();
  }
}
